import { useAalKpisQuery } from "../aalV2";

export type SportsBetsAALKPIsFilters = {
  start_date: string;
  end_date: string;
};

export type SportsBetsAALKPIsResponse = {
  turnover: number;
  turnover_pct_change: number;
  pnl: number;
  pnl_pct_change: number;
  bets_settled_count: number;
  bets_settled_count_pct_change: number;
  amount_realized: number;
  amount_realized_pct_change: number;
  comparison_start_date: string;
  comparison_end_date: string;
} | null;

export const useGetAALSportsBetsKPIs = (
  filters: SportsBetsAALKPIsFilters,
) => {
  const { start_date, end_date } = filters;

  return useAalKpisQuery<SportsBetsAALKPIsResponse>("sports-bets", {
    start_date,
    end_date,
  });
};
